import { render, staticRenderFns } from "./CompanyAttendance.vue?vue&type=template&id=c61f8c66&scoped=true"
import script from "./CompanyAttendance.vue?vue&type=script&lang=js"
export * from "./CompanyAttendance.vue?vue&type=script&lang=js"
import style0 from "./CompanyAttendance.vue?vue&type=style&index=0&id=c61f8c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61f8c66",
  null
  
)

export default component.exports